import React, { useState } from 'react';
import { IconX } from '../Icons';

export default function ManualTradeModal({
  isOpen,
  brokerLabel,
  onClose,
  onSubmit,
  busy = false,
}) {
  const [manual, setManual] = useState({
    symbol: '',
    side: 'Buy',
    qty: '',
    price: '',
    dateTime: '',
  });

  if (!isOpen) return null;

  async function handleSubmit(event) {
    event.preventDefault();
    await onSubmit(manual);
    setManual({ symbol: '', side: 'Buy', qty: '', price: '', dateTime: '' });
  }

  return (
    <div className="vd-modal-backdrop vd-manual-modal-backdrop" role="dialog" aria-modal="true">
      <div className="vd-modal vd-manual-modal">
        <header>
          <div>
            <h3>Manual trade</h3>
            <p className="vd-muted">Add a round-trip trade for {brokerLabel}.</p>
          </div>
          <button type="button" className="vd-modal-close" onClick={onClose} aria-label="Close">
            <IconX size={18} />
          </button>
        </header>

        <form className="vd-form-stack" onSubmit={handleSubmit}>
          <input
            placeholder="Symbol"
            value={manual.symbol}
            onChange={(e) => setManual({ ...manual, symbol: e.target.value })}
            required
          />
          <select value={manual.side} onChange={(e) => setManual({ ...manual, side: e.target.value })}>
            <option value="Buy">Buy</option>
            <option value="Sell">Sell</option>
          </select>
          <input
            placeholder="Quantity"
            value={manual.qty}
            onChange={(e) => setManual({ ...manual, qty: e.target.value })}
            required
          />
          <input
            placeholder="Price"
            value={manual.price}
            onChange={(e) => setManual({ ...manual, price: e.target.value })}
            required
          />
          <input
            type="datetime-local"
            value={manual.dateTime}
            onChange={(e) => setManual({ ...manual, dateTime: e.target.value })}
          />
          <div className="vd-manual-modal-actions">
            <button type="button" className="vd-btn secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="vd-btn" disabled={busy}>
              {busy ? 'Saving…' : 'Save manual trade'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
